import { render, staticRenderFns } from "./TotallyBlockHead.vue?vue&type=template&id=30927934"
import script from "./TotallyBlockHead.vue?vue&type=script&lang=js"
export * from "./TotallyBlockHead.vue?vue&type=script&lang=js"
import style0 from "./TotallyBlockHead.vue?vue&type=style&index=0&id=30927934&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports